import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = { class: "d-flex flex-wrap ga-1 mb-3" }
const _hoisted_3 = { class: "text-caption text-medium-emphasis mt-1" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "pa-2 text-left" }
const _hoisted_8 = { class: "text-subtitle-1 font-weight-bold mb-1" }
const _hoisted_9 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_10 = {
  key: 1,
  class: "d-flex flex-wrap ga-1"
}
const _hoisted_11 = { class: "text-subtitle-1 font-weight-bold mb-1" }
const _hoisted_12 = { class: "text-caption text-medium-emphasis" }

import { compartirSistemaAleman } from "@/composables/useSistemaAleman";
import { compartirTorneoCerrado } from "@/composables/useTorneoCerrado";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { Torneo, TorneoGestionInfoDTO } from "@/interfaces/Torneo";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import {
  getInfoTorneoCreado,
  getPartidasTorneo,
  getTorneo,
  isSaveTournament,
} from "@/services/TorneosService";
import {
  cerrarCopaAsync,
  eliminarEliminatoriaAsync,
  eliminarJornadasCopaAsync,
  generarEliminatoriaAsync,
  generarGruposAsync,
  repartirGruposAsync,
} from "@/services/CopaService";
import {
  DESEMPATE_ORGANIZADOR,
  FASE_GRUPOS,
  REPARTO_ELO,
  REPARTO_MANUAL,
  desempateEliminatoriaOptions,
  repartoGruposOptions,
} from "@/Constant/FormatoTorneo";
import { partidaJugada } from "@/utils/clasificacionLiga";
import {
  clasificacionGrupos,
  clasificadosCopa,
  esDelCuadro,
  montarCuadro,
} from "@/utils/cuadroCopa";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import CardGestionTorneo from "@/components/GestionTorneos/CardGestionTorneo.vue";
import TabMostrarListas from "@/components/GestionTorneos/TabMostrarListas.vue";
import TablaInscritosLiga from "@/components/GestionTorneos/Liga/TablaInscritosLiga.vue";
import TabJornadasLiga from "@/components/GestionTorneos/Liga/TabJornadasLiga.vue";
import TablaClasificacionLiga from "@/components/GestionTorneos/Liga/TablaClasificacionLiga.vue";
import CuadroCopa from "@/components/GestionTorneos/Copa/CuadroCopa.vue";

// Como en el back: cada grupo necesita al menos 2 jugadores
const MINIMO_POR_GRUPO = 2;


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoGestionCopaView',
  setup(__props) {

const route = useRoute();
const idTorneo = Number(route.params.idTorneo);

const tab = ref("gestion");
const isLoading = ref(true);
const torneo = ref<Torneo>();
// Con el sistema alemán, las partidas enseñan también los puntos que dan
compartirSistemaAleman(() => torneo.value?.classificationType);
const torneoGestion = ref<TorneoGestionInfoDTO>();
const partidas = ref<PartidaTorneoDTO[]>([]);
// Con los resultados guardados ya no se retira a nadie ni se toca el cuadro
const cerrada = ref(false);
// Cerrado, las tarjetas y tablas no enseñan lo que ya no se puede cambiar
compartirTorneoCerrado(cerrada);

const cuenta = (n: number, singular: string, plural: string) =>
  `${n} ${n === 1 ? singular : plural}`;

const numeroGrupos = computed(() => torneo.value?.numeroGrupos ?? 1);
const esManual = computed(() => torneo.value?.repartoGrupos === REPARTO_MANUAL);
const etiquetaReparto = computed(
  () =>
    repartoGruposOptions.find(o => o.value === torneo.value?.repartoGrupos)
      ?.label ?? "Por ELO, con bombos"
);
const etiquetaDesempate = computed(() =>
  (
    desempateEliminatoriaOptions.find(
      o => o.value === torneo.value?.desempateEliminatoria
    )?.label ?? "Pasa el mejor de grupos"
  ).toLowerCase()
);

const activos = computed(
  () =>
    torneoGestion.value?.inscripciones.filter(
      i => i.estadoInscripcion !== "RETIRADO"
    ) ?? []
);
const jugadoresActivos = computed(() => activos.value.length);
const minimoJugadores = computed(() => numeroGrupos.value * MINIMO_POR_GRUPO);
const sinGrupo = computed(
  () =>
    activos.value.filter(
      i => !i.grupo || i.grupo < 1 || i.grupo > numeroGrupos.value
    ).length
);
const miembros = (grupo: number) =>
  activos.value
    .filter(i => i.grupo === grupo)
    .sort((a, b) => (a.nick ?? "").localeCompare(b.nick ?? ""));

// Fase de grupos
const partidasGrupos = computed(() =>
  partidas.value.filter(p => p.fase === FASE_GRUPOS)
);
const tieneJornadas = computed(() => partidasGrupos.value.length > 0);
const numeroJornadas = computed(() =>
  partidasGrupos.value.reduce((max, p) => Math.max(max, p.numeroRonda), 0)
);
const jugadasGrupos = computed(
  () => partidasGrupos.value.filter(partidaJugada).length
);
const tieneResultado = (p: PartidaTorneoDTO) =>
  p.resultadoUsuario1 != null ||
  p.resultadoUsuario2 != null ||
  p.partidaValidadaUsuario1 === true ||
  p.partidaValidadaUsuario2 === true;
const gruposConResultado = computed(() =>
  partidasGrupos.value.some(tieneResultado)
);

const grupos = computed(() =>
  clasificacionGrupos(
    partidas.value,
    torneoGestion.value?.inscripciones ?? [],
    numeroGrupos.value,
    torneo.value?.classificationType
  )
);
const clasificacionGrupo = (grupo: number) => grupos.value[grupo - 1] ?? [];
const clasificados = computed(() =>
  clasificadosCopa(
    grupos.value,
    torneoGestion.value?.inscripciones ?? [],
    torneo.value?.clasificadosPorGrupo ?? 0
  )
);

// Eliminatoria
const cuadro = computed(() =>
  montarCuadro(
    partidas.value,
    torneoGestion.value?.inscripciones ?? [],
    torneo.value?.tercerPuesto ?? false
  )
);
const tieneCuadro = computed(() => cuadro.value !== null);
const cruces = computed(() => partidas.value.filter(esDelCuadro));
const crucesJugados = computed(() => cruces.value.filter(partidaJugada).length);
const cuadroConResultado = computed(() => cruces.value.some(tieneResultado));
// Para cerrar la copa, el tercer puesto también tiene que estar decidido
const faltaTercero = computed(
  () => !!cuadro.value?.tercerPuesto && !cuadro.value.tercerPuesto.pasa.idUsuario
);
// La primera ronda que aún tiene algún cruce sin decidir
const rondaEnJuego = computed(
  () =>
    cuadro.value?.rondas.find(r => r.cruces.some(c => c.pasa.pendiente))
      ?.nombre ?? "Final"
);

async function cargar() {
  try {
    const [respTorneo, respGestion, respPartidas, respCerrada] =
      await Promise.all([
        getTorneo(idTorneo),
        getInfoTorneoCreado(idTorneo),
        getPartidasTorneo(idTorneo),
        isSaveTournament(idTorneo),
      ]);
    torneo.value = respTorneo.data;
    torneoGestion.value = respGestion.data;
    partidas.value = respPartidas.data;
    cerrada.value = respCerrada.data === true;
  } catch (error) {
    console.error("Error al cargar la copa:", error);
  } finally {
    isLoading.value = false;
  }
}

onMounted(cargar);

async function recargarPartidas() {
  try {
    partidas.value = (await getPartidasTorneo(idTorneo)).data;
  } catch (error) {
    console.error("Error al recargar las partidas:", error);
  }
}

// Cada resultado puede mover el cuadro y el ELO: se recargan siempre
async function actualizarPartida(actualizada: PartidaTorneoDTO) {
  const i = partidas.value.findIndex(
    p => p.idPartidaTorneo === actualizada.idPartidaTorneo
  );
  if (i !== -1) partidas.value[i] = { ...partidas.value[i], ...actualizada };
  await recargarPartidas();
}

// Confirmaciones
const showConfirmar = ref(false);
const confirmar = ref<{
  titulo: string;
  texto: string;
  color: string;
  accion: () => Promise<void>;
}>({ titulo: "", texto: "", color: "primary", accion: () => Promise.resolve() });

function pedir(
  titulo: string,
  texto: string,
  color: string,
  accion: () => Promise<void>
) {
  confirmar.value = { titulo, texto, color, accion };
  showConfirmar.value = true;
}

async function ejecutarConfirmado() {
  showConfirmar.value = false;
  await confirmar.value.accion();
}

const isGuardando = ref(false);
const showSuccess = ref(false);
const showError = ref(false);
const mensaje = ref("");

async function ejecutar(
  accion: () => Promise<unknown>,
  exito: string,
  fallo: string
) {
  isGuardando.value = true;
  try {
    await accion();
    mensaje.value = exito;
    showSuccess.value = true;
    await cargar();
  } catch (error) {
    mensaje.value = mensajeDelBack(error, fallo);
    showError.value = true;
  } finally {
    isGuardando.value = false;
  }
}

function pedirRepartir() {
  const como =
    torneo.value?.repartoGrupos === REPARTO_ELO
      ? "por ELO: los mejores, uno en cada grupo, y el resto por bombos"
      : "al azar";
  pedir(
    "¿Repartir los grupos?",
    `Los ${jugadoresActivos.value} jugadores se reparten en ${numeroGrupos.value} grupos ${como}. Si ya estaban repartidos, se hace de nuevo. Después puedes mover a quien quieras.`,
    "primary",
    () =>
      ejecutar(
        () => repartirGruposAsync(idTorneo),
        "Grupos repartidos.",
        "No se han podido repartir los grupos."
      )
  );
}

function pedirGenerarGrupos() {
  pedir(
    "¿Generar las jornadas de los grupos?",
    `En cada grupo juegan todos contra todos${torneo.value?.idaYVuelta ? ", ida y vuelta" : ""}. Se cierran las inscripciones y cada jugador recibe un correo.`,
    "primary",
    () =>
      ejecutar(
        () => generarGruposAsync(idTorneo),
        "Jornadas generadas.",
        "No se han podido generar las jornadas."
      )
  );
}

function pedirEliminarJornadas() {
  pedir(
    "¿Eliminar las jornadas?",
    "Se borran las partidas de los grupos para poder repartirlos otra vez. Los jugadores se quedan en su grupo. Solo se puede mientras no haya ningún resultado.",
    "error",
    () =>
      ejecutar(
        () => eliminarJornadasCopaAsync(idTorneo),
        "Jornadas eliminadas.",
        "No se han podido eliminar las jornadas."
      )
  );
}

function pedirEliminatoria() {
  const pendientes = partidasGrupos.value.length - jugadasGrupos.value;
  pedir(
    "¿Cerrar los grupos y generar la eliminatoria?",
    `Pasan los ${torneo.value?.clasificadosPorGrupo} primeros de cada grupo; si no llenan el cuadro, entran los mejores siguientes.${
      pendientes > 0
        ? ` ${pendientes === 1 ? "Queda 1 partida de grupos sin jugar, que ya no cuenta." : `Quedan ${pendientes} partidas de grupos sin jugar, que ya no cuentan.`}`
        : ""
    }`,
    "primary",
    () =>
      ejecutar(
        () => generarEliminatoriaAsync(idTorneo),
        "Eliminatoria generada.",
        "No se ha podido generar la eliminatoria."
      )
  );
}

function pedirEliminarEliminatoria() {
  pedir(
    "¿Eliminar la eliminatoria?",
    "Se borra el cuadro para volver a la fase de grupos. Solo se puede mientras ningún cruce tenga resultado.",
    "error",
    () =>
      ejecutar(
        () => eliminarEliminatoriaAsync(idTorneo),
        "Eliminatoria eliminada.",
        "No se ha podido eliminar la eliminatoria."
      )
  );
}

function pedirCerrar() {
  pedir(
    "¿Cerrar la copa y guardar los resultados?",
    `Se guarda la clasificación final: campeón, finalista, ${torneo.value?.tercerPuesto ? "tercero y cuarto" : "semifinalistas"}, luego los que caen en cada ronda y por último los que no pasaron de grupos. Después ya no se puede retirar a nadie ni tocar el cuadro.`,
    "primary",
    () =>
      ejecutar(
        () => cerrarCopaAsync(idTorneo),
        "Copa cerrada y resultados guardados.",
        "No se ha podido cerrar la copa."
      )
  );
}

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-2 pa-sm-4" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingGandalf)
          ]))
        : (torneoGestion.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              class: "mx-auto",
              "max-width": "800"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
                  "show-arrows": "",
                  grow: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "gestion" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Gestión")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "grupos" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Grupos")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "jornadas" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Jornadas")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "eliminatoria" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Eliminatoria")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "listas" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Listas")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_tabs_window, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tabs_window_item, { value: "gestion" }, {
                      default: _withCtx(() => [
                        _createVNode(CardGestionTorneo, { torneo: torneoGestion.value }, null, 8, ["torneo"]),
                        _createVNode(_component_v_card, { class: "mb-4 text-left" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Copa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_component_v_chip, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(cuenta(numeroGrupos.value, "grupo", "grupos")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_chip, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Pasan " + _toDisplayString(torneo.value?.clasificadosPorGrupo) + " por grupo ", 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_chip, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(etiquetaReparto.value), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_chip, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(torneo.value?.idaYVuelta ? "Grupos a ida y vuelta" : "Grupos a solo ida"), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_chip, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Empates: " + _toDisplayString(etiquetaDesempate.value), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (torneo.value?.tercerPuesto)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Con tercer puesto ")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_chip, {
                                    size: "small",
                                    color: torneo.value?.cuentaElo ? 'primary' : undefined
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(torneo.value?.cuentaElo
                      ? "Cuenta para el ELO"
                      : "No cuenta para el ELO"), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"]),
                                  (cerrada.value)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        size: "small",
                                        color: "success"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Cerrada ")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                (!tieneJornadas.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("p", null, [
                                        _createTextVNode(_toDisplayString(cuenta(jugadoresActivos.value, "jugador", "jugadores")) + " en " + _toDisplayString(cuenta(numeroGrupos.value, "grupo", "grupos")) + ". ", 1),
                                        (sinGrupo.value > 0)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" Faltan " + _toDisplayString(sinGrupo.value) + " por colocar en un grupo. ", 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode("Todos tienen grupo.")
                                            ], 64))
                                      ]),
                                      _createElementVNode("p", _hoisted_3, [
                                        (esManual.value)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" El reparto es a mano: pon a cada jugador en su grupo desde su menú. ")
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(" Reparte los grupos y, si hace falta, mueve a quien quieras desde su menú. ")
                                            ], 64)),
                                        _createTextVNode(" Al generar las jornadas se cierran las inscripciones y cada jugador recibe un correo. ")
                                      ])
                                    ], 64))
                                  : (!tieneCuadro.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Fase de grupos: " + _toDisplayString(cuenta(numeroJornadas.value, "jornada", "jornadas")) + " · " + _toDisplayString(cuenta(partidasGrupos.value.length, "partida", "partidas")) + " · " + _toDisplayString(cuenta(jugadasGrupos.value, "jugada", "jugadas")), 1))
                                    : (cuadro.value?.campeon.idUsuario)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                          _createTextVNode(_toDisplayString(faltaTercero.value ? "Final jugada" : "Eliminatoria terminada") + ". Campeón: ", 1),
                                          _createElementVNode("strong", null, _toDisplayString(cuadro.value.campeon.nick), 1),
                                          _createTextVNode(". "),
                                          (faltaTercero.value)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode("Falta el tercer puesto.")
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_6, " Eliminatoria: " + _toDisplayString(rondaEnJuego.value) + " · " + _toDisplayString(cuenta(crucesJugados.value, "cruce jugado", "cruces jugados")), 1))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_actions, { class: "flex-wrap ga-2 justify-center" }, {
                              default: _withCtx(() => [
                                (!tieneJornadas.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (!esManual.value)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            color: "primary",
                                            variant: "tonal",
                                            disabled: jugadoresActivos.value < minimoJugadores.value,
                                            onClick: pedirRepartir
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(sinGrupo.value < jugadoresActivos.value ? "Volver a repartir" : "Repartir grupos"), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        variant: "flat",
                                        disabled: sinGrupo.value > 0 || jugadoresActivos.value < minimoJugadores.value,
                                        onClick: pedirGenerarGrupos
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Generar jornadas ")
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ], 64))
                                  : (!tieneCuadro.value && !cerrada.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (!gruposConResultado.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              color: "error",
                                              variant: "tonal",
                                              onClick: pedirEliminarJornadas
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Eliminar jornadas ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_btn, {
                                          color: "primary",
                                          variant: "flat",
                                          onClick: pedirEliminatoria
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Generar eliminatoria ")
                                          ]),
                                          _: 1
                                        })
                                      ], 64))
                                    : (tieneCuadro.value && !cerrada.value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          (!cuadroConResultado.value)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                color: "error",
                                                variant: "tonal",
                                                onClick: pedirEliminarEliminatoria
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Eliminar eliminatoria ")
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (cuadro.value?.campeon.idUsuario && !faltaTercero.value)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                color: "primary",
                                                variant: "flat",
                                                onClick: pedirCerrar
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Cerrar copa y guardar resultados ")
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (!tieneJornadas.value && jugadoresActivos.value < minimoJugadores.value)
                              ? (_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 0,
                                  class: "pt-0 text-caption"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Hacen falta al menos " + _toDisplayString(minimoJugadores.value) + " jugadores para " + _toDisplayString(cuenta(numeroGrupos.value, "grupo", "grupos")) + ". ", 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(TablaInscritosLiga, {
                          torneo: torneoGestion.value,
                          ligaGenerada: tieneJornadas.value,
                          ligaCerrada: cerrada.value,
                          numeroGrupos: numeroGrupos.value,
                          enEliminatoria: tieneCuadro.value,
                          onActualizado: cargar
                        }, null, 8, ["torneo", "ligaGenerada", "ligaCerrada", "numeroGrupos", "enEliminatoria"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tabs_window_item, { value: "grupos" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          (!tieneJornadas.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_v_alert, {
                                  type: "info",
                                  variant: "tonal",
                                  density: "compact",
                                  class: "mb-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" La clasificación de cada grupo aparece al generar las jornadas. ")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numeroGrupos.value, (g) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: g,
                                    class: "mb-4"
                                  }, [
                                    _createElementVNode("h3", _hoisted_8, "Grupo " + _toDisplayString(g), 1),
                                    (miembros(g).length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Aún no hay nadie. "))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(miembros(g), (i) => {
                                            return (_openBlock(), _createBlock(_component_v_chip, {
                                              key: i.idInscripcion,
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(i.nick), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]))
                                  ]))
                                }), 128))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numeroGrupos.value, (g) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: g,
                                    class: "mb-4"
                                  }, [
                                    _createElementVNode("h3", _hoisted_11, "Grupo " + _toDisplayString(g), 1),
                                    _createVNode(TablaClasificacionLiga, {
                                      filas: clasificacionGrupo(g),
                                      clasificados: clasificados.value,
                                      sinNota: ""
                                    }, null, 8, ["filas", "clasificados"])
                                  ]))
                                }), 128)),
                                _createElementVNode("p", _hoisted_12, [
                                  _createTextVNode(" Marcados en verde, los que pasan a la eliminatoria"),
                                  (!tieneCuadro.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" si acabaran ahora; si no llenan el cuadro, entran los mejores siguientes")
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(". Solo cuentan las partidas validadas por los dos jugadores. Desempate: puntos, diferencia, puntos a favor y generales. ")
                                ])
                              ], 64))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tabs_window_item, { value: "jornadas" }, {
                      default: _withCtx(() => [
                        (!tieneJornadas.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: "info",
                              variant: "tonal",
                              class: "ma-4"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Los grupos aún no tienen jornadas. Genéralas desde la pestaña Gestión cuando cierres las inscripciones. ")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(TabJornadasLiga, {
                              key: 1,
                              partidas: partidasGrupos.value,
                              jornadas: numeroJornadas.value,
                              editable: true,
                              numeroGrupos: numeroGrupos.value,
                              onPartidaActualizada: actualizarPartida
                            }, null, 8, ["partidas", "jornadas", "numeroGrupos"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tabs_window_item, { value: "eliminatoria" }, {
                      default: _withCtx(() => [
                        (!cuadro.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: "info",
                              variant: "tonal",
                              class: "ma-4"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" La eliminatoria se genera desde la pestaña Gestión cuando acaben los grupos. ")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(CuadroCopa, {
                              key: 1,
                              idTorneo: _unref(idTorneo),
                              cuadro: cuadro.value,
                              editable: true,
                              desempateOrganizador: torneo.value?.desempateEliminatoria === _unref(DESEMPATE_ORGANIZADOR),
                              cerrada: cerrada.value,
                              onPartidaActualizada: actualizarPartida,
                              onActualizado: recargarPartidas
                            }, null, 8, ["idTorneo", "cuadro", "desempateOrganizador", "cerrada"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tabs_window_item, { value: "listas" }, {
                      default: _withCtx(() => [
                        _createVNode(TabMostrarListas, { torneo: torneo.value }, null, 8, ["torneo"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: showConfirmar.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showConfirmar).value = $event)),
        "max-width": "420"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(confirmar.value.titulo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(confirmar.value.texto), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "grey",
                    variant: "text",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showConfirmar.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancelar ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: confirmar.value.color,
                    variant: "tonal",
                    onClick: ejecutarConfirmado
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Confirmar ")
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: isGuardando.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isGuardando).value = $event)),
        persistent: "",
        width: "200"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "pa-6 d-flex justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "60"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ModalSuccess, {
        isVisible: showSuccess.value,
        message: mensaje.value,
        "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = $event))
      }, null, 8, ["isVisible", "message"]),
      _createVNode(ModalError, {
        isVisible: showError.value,
        message: mensaje.value,
        "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showError.value = $event))
      }, null, 8, ["isVisible", "message"])
    ]),
    _: 1
  }))
}
}

})